import { render } from "./GoalList.vue?vue&type=template&id=65e45b13"
import script from "./GoalList.vue?vue&type=script&lang=js"
export * from "./GoalList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__